import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { CommonFunctions } from '../static/common-functions';
import { CommonValues } from '../static/CommonValues';

export class TimeDetailBus extends BaseBus
{
    CID() : any {
        return this.rowId;
    }
    setId(id: any) {
        this.rowId = id;
    }
    setEmptyGuidToNull = false;
    constructor(data: TimeDetailBus = null) {
        super(data);

        if (data !== undefined && data !== null) {
            this.startDate = CommonFunctions.getDate(data.startDate);
            this.endDate = CommonFunctions.getDate(data.endDate);
            this.mgrApprovedDt = CommonFunctions.getDate(data.mgrApprovedDt);
            this.retroDate = CommonFunctions.getDate(data.retroDate);
            this.sageDt = CommonFunctions.getDate(data.sageDt);
            if (data.endDate) {
                this.hours = DateFunctions.dateDiffHours(this.startDate, this.endDate);
            }
            else {
                this.hours = data.hours;
            }
            //        this.hrsApproved = data.mgrApproved; is set from SP like this in OG }
        }
    }
    setFromForm(data: TimeDetailBus) {
        console.log("td-bus->sff: ", data, this);
        super.setFromForm(data);
        this.hours = DateFunctions.dateDiffHours(data.startDate, data.endDate);
    }
    setBeforeSave() {
        this.startDate = DateFunctions.getDateTimeWithUTCOffset(this.startDate);
        this.endDate = DateFunctions.getDateTimeWithUTCOffset(this.endDate);
        if (!this.mgrId) { this.mgrId = CommonValues.Guid_Empty; }
    }
    startDate: Date;
    endDateFmt: string;
    endDate: Date;
    dispatchNumber: string;
    dispatchReason: string;
    laborTypeName: string;
    payTypeId: any;
    timeTypeName: string;
    timeTypeId: any;
    totalTime: string;
    name: string;
    firstName: string;
    lastName: string;
    mgrName: string;
    personId: any;
    dispatchId: any;
    nonPaid: boolean;
    city: string;
    locationName: string;
    addressLine1: string;
    stateProvince: string;
    quickSearchKey: string;
    dispatchLaborId: any;
    empNo: string;
    afterPayroll: boolean;
    useLocationRate: boolean;
    hrsApproved: boolean;
    mgrApproved: boolean;
    isHelper: boolean;
    hours: number;
    timeSource: number;
    rowId: any;
    mgrId: any;
    isBillable: boolean;
    isCertPay: boolean;
    set pto(value: number) {

    }
    get pto(): number {
        return this.timeSource === 3 ? this.hours : null;
    }
    get startDateDateOnly(): Date {
        return CommonFunctions.getDate(this.startDate);
    }
    //if(detail.Source == 3) detail.PTO = (double?)NullTypes.NullToNullableDecimal(reader["Hours"]);
   // endDtNull: Date;
    aprvdName: string;
    mgrApprovedDt: Date;
    get inFinance() : boolean {
        return CommonFunctions.hasValue(this.sageDt);
    }
    set inFinance(value: boolean) { }
    retroDate: Date;
    sageDt: Date;
    get canEdit(): boolean {
        return !this.originalMgrApproved;
    }
    set canEdit(value: boolean) { }
    originalMgrApproved: boolean;
    isBeingApproved: boolean = false;
}
